import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  limit?: number;
};

export const adminGetProjects = createQueryFn(
  QueryNameSpace.adminGetProjects,
  async ({
    queryKey,
    pageParam,
  }: QueryFunctionContext<[string] | [string, Params], string[]>) => {
    const [, params] = queryKey;
    const res = await DigiobcanApi.adminGetProjects({
      ...params,
      pagecursor: pageParam,
    });

    return res.projects;
  },
);
